var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagician(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 426.44 477.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 217.14,
    y1: 24.28,
    x2: 308.98,
    y2: 197.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 113.39,
    y1: 197.01,
    x2: 217.14,
    y2: 24.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 217.14,
    y1: 159.95,
    x2: 217.14,
    y2: 452.86
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "222.08 475 212.49 460.17 194.99 457.8 209.82 448.21 212.19 430.71 221.78 445.54 239.28 447.91 224.45 457.5 222.08 475"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "195.59 17.18 213.23 16.55 224.24 2.74 224.87 20.38 238.68 31.39 221.04 32.02 210.03 45.83 209.4 28.19 195.59 17.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.59 215.75 104.87 198.62 94.66 184.22 111.79 188.5 126.19 178.28 121.91 195.41 132.12 209.81 114.99 205.53 100.59 215.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "296.18 215.75 300.47 198.62 290.25 184.22 307.38 188.5 321.78 178.28 317.5 195.41 327.71 209.81 310.59 205.53 296.18 215.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.09 100.84 27.67 92.36 18.76 105.49 19.4 89.63 3.57 88.48 17.62 81.1 10.71 66.82 24.12 75.3 33.03 62.17 32.39 78.03 48.22 79.18 34.17 86.56 41.09 100.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "394.52 105.76 394.52 89.89 378.66 89.37 392.4 81.44 384.92 67.44 398.66 75.38 407.04 61.9 407.04 77.77 422.9 78.28 409.16 86.22 416.65 100.22 402.9 92.28 394.52 105.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "210.88 181.88 210.88 166.01 195.01 165.5 208.76 157.56 201.27 143.56 215.02 151.5 223.4 138.02 223.4 153.89 239.26 154.4 225.51 162.34 233 176.34 219.25 168.4 210.88 181.88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagician);
export default __webpack_public_path__ + "static/media/Magician.cda552371b27b4872eef8b88cb26ae42.svg";
export { ForwardRef as ReactComponent };